import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Impayes, Paiement, Partage } from '../../models/finance.model';

/** Paiements, restes dus et journal des envois */
@Injectable({ providedIn: 'root' })
export class PaiementService {
  private base = `${environment.BASE_URL}/api`;

  constructor(private http: HttpClient) {}

  lister(fermeId: number, filtre: { revenuId?: number; depenseId?: number; factureId?: number; contactId?: number } = {}): Observable<Paiement[]> {
    let p = new HttpParams().set('fermeId', fermeId);
    Object.entries(filtre).forEach(([k, v]) => { if (v != null) p = p.set(k, String(v)); });
    return this.http.get<Paiement[]>(`${this.base}/paiements`, { params: p });
  }

  enregistrer(p: Paiement): Observable<Paiement> {
    return this.http.post<Paiement>(`${this.base}/paiements`, p);
  }

  annuler(id: number, motif?: string): Observable<Paiement> {
    return this.http.post<Paiement>(`${this.base}/paiements/${id}/annuler`, {}, { params: motif ? { motif } : {} });
  }

  /** Reçu PDF d'un encaissement */
  recuPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.base}/paiements/${id}/recu.pdf`, { responseType: 'blob' });
  }

  /** Archive le reçu dans Documents et renvoie son lien de partage */
  archiverRecu(id: number): Observable<{ documentId: number; lienPublic?: string }> {
    return this.http.post<{ documentId: number; lienPublic?: string }>(`${this.base}/paiements/${id}/recu`, {});
  }

  impayes(fermeId: number, sens: 'CLIENT' | 'FOURNISSEUR'): Observable<Impayes> {
    return this.http.get<Impayes>(`${this.base}/finances/impayes`, { params: { fermeId, sens } });
  }

  journaliser(p: Partage): Observable<Partage> {
    return this.http.post<Partage>(`${this.base}/partages`, p);
  }

  confirmerPartage(id: number): Observable<Partage> {
    return this.http.post<Partage>(`${this.base}/partages/${id}/confirmer`, {});
  }

  partages(fermeId: number, filtre: { factureId?: number; contactId?: number; documentId?: number } = {}): Observable<Partage[]> {
    let p = new HttpParams().set('fermeId', fermeId);
    Object.entries(filtre).forEach(([k, v]) => { if (v != null) p = p.set(k, String(v)); });
    return this.http.get<Partage[]>(`${this.base}/partages`, { params: p });
  }
}
